import { padTwoDigits } from './pad-two-digits'

export const toBackendDateTimeString = (date: Date) =>
  `${date.getFullYear()}-${padTwoDigits(date.getMonth() + 1)}-${padTwoDigits(date.getDate())} ` +
  `${padTwoDigits(date.getHours())}:${padTwoDigits(date.getMinutes())}`
